export default class SeekingAI {
  constructor(game, location, slots, seeker, quickFind) {
    this.game = game;
    this.location = location;
    this.slots = slots; // slots with characters to find
    this.seeker = seeker;
    this.quickFind = quickFind;
    this.targetSlot = null;

    this.onFindChar = new Phaser.Signal();
    this.onShowExplainer = new Phaser.Signal();
  }

  getNextTarget() {
    this.slots.sort((a, b) => a.rating - b.rating);
    const rating = this.slots[0].rating;

    // get slots with same lowest rating
    const targets = this.slots.filter((e) => e.rating === rating);

    // find closest
    let min = 10000;
    for (let i = 0; i < targets.length; i++) {
      const dx = Math.abs(this.seeker.x - targets[i].getCharacterPos().x);
      if (dx < min) {
        min = dx;
        this.targetSlot = targets[i];
      }
    }

    this.startSearching();
  }

  startSearching() {
    // make seeker go to the target
    if (this.targetSlot.rating === 0 || this.quickFind) {
      // easy - go directly to position
      const tx = this.targetSlot.getCharacterPos().x;
      const dx = this.seeker.x - tx;
      const x = tx + 200 * (dx > 0 ? 1 : -1);
      this.seeker.onPosition.addOnce(this.handleSeekerOnPosition, this);
      this.seeker.gotoPosition(x);
    } else if (this.targetSlot.rating === 1) {
      // medium - go closer the target
      const tx = this.targetSlot.getCharacterPos().x;
      const dx = this.seeker.x - tx;
      const x = tx + 350 * (dx > 0 ? 1 : -1);
      this.seeker.onPosition.addOnce(this.handleSeekerOnPosition1, this);
      this.seeker.gotoPosition(x);
    } else {
      // walk over the location first
      const tx = this.targetSlot.getCharacterPos().x;
      const dx = this.seeker.x - tx;
      this.destX = tx + 200 * (dx > 0 ? 1 : -1);

      this.voCounter = 0; // used to play voiceover when seeker is looking for other

      //
      if (Math.abs(dx) < 1000) {
        // go somewhere, stop, think, return to target, think, reveal
        let x = 0;
        if (this.destX < 800) {
          x = this.destX + 800;
        } else if (this.destX > this.location.width - 800) {
          x = this.destX - 800;
        } else {
          x = this.destX + 800 * (dx > 0 ? 1 : -1);
        }
        this.seeker.onPosition.addOnce(this.handleSeekerOnWayPoint, this);
        this.seeker.gotoPosition(x);
      } else {
        // go to the target, and stop & think every 800 pixels
        this.handleThinkingEnd3();
      }
    }
  }

  handleSeekerOnWayPoint() {
    this.seeker.think();
    this.seeker.onAnimEnd.addOnce(this.handleThinkingEnd3, this);

    if (this.voCounter % 2 === 0) {
      const snd = 'vo_01_' + this.seeker.seekerId + '_';
      const ind = (3 * Math.random()) | 0;
      const ids = ['026', '027', '028'];
      const textId = snd + ids[ind];
      this.game.springRollCaptionsPlugin.playCaption(textId);
      this.game.sounds.playVO(textId, {
        spriteID: this.seeker.seekerId + '_vo',
      });
    }
    this.voCounter++;
  }

  handleThinkingEnd3() {
    const dx = this.destX - this.seeker.x;
    if (Math.abs(dx) <= 800) {
      // go to target
      this.seeker.onPosition.addOnce(this.handleSeekerOnPosition, this);
      this.seeker.gotoPosition(this.destX);
    } else {
      // go closer to the target
      const x = this.seeker.x + 700 * (dx > 0 ? 1 : -1);
      this.seeker.onPosition.addOnce(this.handleSeekerOnWayPoint, this);
      this.seeker.gotoPosition(x);
    }
  }

  handleSeekerOnPosition1() {
    this.seeker.think();
    this.seeker.onAnimEnd.addOnce(this.handleThinkingEndMedium, this);
  }

  handleThinkingEndMedium() {
    this.seeker.idle();
    this.game.time.events.add(1000, this.gotoTarget, this);
  }

  gotoTarget() {
    const tx = this.targetSlot.getCharacterPos().x;
    const dx = this.seeker.x - tx;
    const x = tx + 200 * (dx > 0 ? 1 : -1);
    this.seeker.onPosition.addOnce(this.handleSeekerOnPosition, this);
    this.seeker.gotoPosition(x);
  }

  handleSeekerOnPosition() {
    console.log('handleSeekerOnPosition');
    const pos = this.targetSlot.getCharacterPos();
    this.game.state.getCurrentState().makeScreenshot(pos.x, pos.y, this.targetSlot.character);
    // this.onShowExplainer.dispatch(this.targetSlot); // debug

    //
    const tx = this.targetSlot.getCharacterPos().x;
    const dx = tx - this.seeker.x;
    this.seeker.setDirection(dx > 0 ? -1 : 1);

    //
    if (this.targetSlot.rating === 0 || this.quickFind) {
      this.seeker.think();
      this.seeker.onAnimEnd.addOnce(this.handleThinkingEnd, this);
    } else if (this.targetSlot.rating === 1) {
      this.seeker.think();
      this.seeker.onAnimEnd.addOnce(this.handleThinkingEnd, this);
    } else {
      this.seeker.think();
      this.seeker.onAnimEnd.addOnce(this.handleThinkingEnd2, this);
    }
  }

  handleThinkingEnd2() {
    this.seeker.idle();
    this.targetSlot.character.hudSlotRef.setStateClue();
    this.game.time.events.add(100, this.wiggleChar, this);
  }

  wiggleChar() {
    this.targetSlot.character.wiggle();
    this.game.time.events.add(1000, this.seekerReactionOnWiggle, this);
  }

  seekerReactionOnWiggle() {
    const textId = 'vo_01_' + this.seeker.seekerId + '_015';
    this.game.springRollCaptionsPlugin.playCaption(textId);
    this.game.sounds.playVO(textId, {
      spriteID: this.seeker.seekerId + '_vo',
    });
    this.seeker.talk(1000);
    this.seeker.onAnimEnd.addOnce(this.jumpUpChar, this);
  }

  jumpUpChar() {
    this.targetSlot.character.jumpUp();
    this.game.time.events.add(1000, this.showBestHiddenChar, this);
  }

  seekerReactionOnJumpUp() {
    const textId = 'vo_01_' + this.seeker.seekerId + '_012';
    this.game.springRollCaptionsPlugin.playCaption(textId);
    this.game.sounds.playVO(textId, {
      spriteID: this.seeker.seekerId + '_vo',
    });
    this.seeker.talk(1700);
    this.seeker.onAnimEnd.addOnce(this.showBestHiddenChar, this);
  }

  showBestHiddenChar() {
    this.handlePointingEnd();
  }

  handleThinkingEnd() {
    console.log('handleThinkingEnd');
    this.seeker.idle();
    this.game.time.events.add(1000, this.pointTarget, this);
  }

  pointTarget() {
    console.log('pointTarget');
    this.seeker.pointCharacter();
    this.seeker.onAnimEnd.addOnce(this.handlePointingEnd, this);
  }

  handlePointingEnd() {
    console.log('handlePointingEnd');
    // say something
    this.onFindChar.dispatch(this.targetSlot.character.charData.id, this.targetSlot);

    this.game.time.events.add(1500, this.celebrate, this);
  }

  celebrate() {
    console.log('celebrate');
    // reveal character
    this.targetSlot.revealCharacter();

    // seeker celebrating
    this.seeker.celebrate();
    this.seeker.onAnimEnd.addOnce(this.handleCelebratingEnd, this);
  }

  handleCelebratingEnd() {
    this.seeker.idle();

    // remove current target from list
    this.slots.splice(this.slots.indexOf(this.targetSlot), 1);

    this.targetSlot = null;
    if (this.slots.length > 0) {
      // find next character
      this.getNextTarget();
    }

    // show next target or explainer
    // if (this.slots.length < 2) {
    //   this.onShowExplainer.dispatch(this.targetSlot);
    //   this.targetSlot = null;
    // } else {
    //   this.targetSlot = null;
    //   this.getNextTarget();
    // }
  }

  afterExplainer() {
    if (this.slots.length > 0) {
      // find next character
      this.getNextTarget();
    } else {
      // end game
    }
  }
}
